import RegisztralasForm from "../components/RegisztralasForm";

function Regisztralas() {
  return <RegisztralasForm />;
}

export default Regisztralas;
